export default "__VITE_ASSET__xV6y4N4R__"